module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate1_en.2b692fb30512d0d0828733ba9855cf94.png";